{
  "en": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Change responsible"
      },
      "attributes": {
        "introduction": "Introduction",
        "responsible": "Responsible",
        "title": "Title"
      },
      "labels": {
        "ask_question": "What kind of question do you want to ask?",
        "editInternalTitle": "Edit the internal title?",
        "explainerNPSPart1": "The Net Promoter Score is an index ranging from -100 to 100 that measures the willingness of customers to recommend your company or projects to others.",
        "explainerOpinionScale": "Measure your customers agreement with a general statement.",
        "fixed_choice": "Multiple-choice question",
        "hidePreview": "Hide preview",
        "moreInfo": "More info",
        "nps": "Net Promoter Score",
        "npsQuestion": "NPS",
        "open_ended": "Open ended",
        "opinion_scale": "Opinion scale",
        "preview": "Preview",
        "satisfaction": "Satisfaction",
        "selectSurveyType": "Select survey",
        "showPreview": "Show preview",
        "tab_summary": "Summary",
        "tab_units": "Units",
        "yes_no": "Yes-No"
      },
      "navigation": {
        "backToSurveyTypes": "Back to surveys"
      },
      "snackbars": {
        "duplicate": "Survey has been created, however the copying process from the template might take a few minutes to complete."
      },
      "toasts": {
        "bulk_delete": "Survey successfully deleted | Surveys successfully deleted",
        "update": "Survey successfully updated"
      },
      "validation": {
        "nameAlreadyTaken": "Name is already taken for this project",
        "need_name": "Title required",
        "selectSurveyType": "Select at least 1 survey"
      }
    }
  }
}